import { api } from './apiService';
import axios from "axios";

// const BASE_URL = "http://localhost:5000";
const BASE_URL = "http://localhost:5001";

export async function getUserById(userId) {
  const response = await api.get(`/users/profile/${userId}`);
  return response.data;
}

export async function createList(listData) {
  const response = await api.post(`/profile/list`, listData);
  return response.data;
}

/**
 * Create a list with profiles by LinkedIn usernames (e.g. from person-search results)
 * @param {{ name: string, description?: string, linkedinUsernames?: string[] }} payload
 * @returns {Promise<Object>} Created list response
 */
export async function createListWithProfiles({ name, description = '', linkedinUsernames = [] }) {
  const response = await api.post('/lists/with-profiles', {
    name,
    description: description || '',
    linkedinUsernames
  });
  return response.data;
}

export async function getLists() {
  const response = await api.get(`/profile/list`);
  return response.data;
}

export async function getListById(listId) {
  const response = await api.get(`/profile/list/${listId}`);
  return response.data;
}

export async function deleteList(listId) {
  const response = await api.delete(`/profile/list/${listId}`);
  return response.data;
}

export async function updateList(listId, listData) {
  const response = await api.put(`/lists/${listId}`, listData);
  return response.data;
} 

export async function addProfileToList(listId, profileId) {
  const data = {
    listId: listId,
    profileId: profileId,
  }
  const response = await api.post(`/profile/addtolist`, data);
  return response.data;
}

export async function removeProfileFromList(listId, profileId) {
  const data = {
    listId: listId,
    profileId: profileId,
  }
  const response = await api.post(`/profile/removefromlist`, data);
  return response.data;
}

export async function updateUserProfile(userId, profileData) {
  const response = await api.put(`/users/profile/${userId}`, profileData);
  return response.data;
}

export async function getContactsByLinkedinUsername(linkedinUsername) {
  const response = await api.get(`/profile/contacts/${linkedinUsername}`);
  return response.data;
}

export async function getSearches() {
  const response = await api.get(`/users/searches`);
  return response.data;
}

export async function evaluateProfile(linkedinUsername, evaluationText) {
  const data = {
    linkedinUsername: linkedinUsername,
    evaluationText: evaluationText
  };
  const response = await api.post(`/profile/evaluate`, data);
  return response.data;
}

export async function createTeam(teamData) {
  const response = await api.post(`/teams`, teamData);
  return response.data;
}

export async function getTeams() {
  const response = await api.get(`/teams`);
  return response.data;
}

//export async function deleteTeam(teamId) {
//  const response = await api.delete(`/teams/${teamId}`);
//  return response.data;
//}

export async function getTeamById(teamId) {
  const response = await api.get(`/teams/${teamId}`);
  return response.data;
}

export async function shareList(listId, emailAddresses) {
  const data = {
    emailAddresses: emailAddresses
  };
  const response = await api.post(`/profile/list/${listId}/share`, data);
  return response.data;
}

export async function getPublicList(shareToken) {
  const response = await api.get(`/public/list/${shareToken}`);
  return response.data;
}

export async function getSharedLists() {
  const response = await api.get(`/lists/shared`);
  return response.data;
}

export async function submitProfileFeedback(listId, feedbackPayload) {
  const response = await api.post(`/profile/list/${listId}/feedback`, feedbackPayload);
  return response.data;
}

export async function deleteTeamMember(userId) {
  const response = await api.delete(`/teams/member/${userId}`);
  return response.data;
}